@use '@design/design-tokens/typography/typography' as *;

.root {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  padding: 100px 0;
  width: 100%;
}

.textWrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.title {
  @include typography-v2-title-base;
  color: var(--text-default);
}

.viewPastNotificationsButton {
  @include typography-v2-ui-xs;
  color: var(--text-primary);
  cursor: pointer;
}
